import { render, staticRenderFns } from "./product-summary-travel-insurance-card.vue?vue&type=template&id=5b59ce08&scoped=true"
import script from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
export * from "./product-summary-travel-insurance-card.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./product-summary-travel-insurance-card.vue?vue&type=style&index=0&id=5b59ce08&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b59ce08",
  null
  
)

export default component.exports